<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {

    }
  },
  created() {
    // localStorage.setItem('token', '2-123')
    // localStorage.setItem('chainAddr', '5CAVc9cX8xtnV4CWjS3Eew5hStfZx18QHJrgTouA1qVXf5oa')
    // let token = localStorage.getItem('token')
    // if (token) {
    //   this.$scoket.scoket(token)
    // }
    // this.exchangeRateData()

  },
  methods: {

  },
}
</script>

<style lang="less">
// 全局引入字体包
@font-face {
  font-family: 'PingFang SC';
  src: url('./assets/fonts/yugothib-2.woff2') format('woff2');
}

* {
  box-sizing: border-box;
  font-family: 'PingFang SC';
}

html,
body {
  margin: 0;
  padding: 0;
  border: 0;
  width: 100%;
  min-height: 100vh;
  background: #F4F4F6;
}

// // 分页样式
// .pagingBox {
//   padding-top: 10px;
//   display: flex;
//   justify-content: center;
//   align-items: center;

//   .el-pager li {
//     font-size: 14px;
//   }
// }

input,
textarea {
  background: none;
  outline: none;
  border: none;
  padding: 0;
}

input::input-placeholder {
  color: rgba(29, 34, 36, 0.4);
}

// 修改滚动条样式
/* 全局样式，作用于所有滚动条 */
::-webkit-scrollbar {
  width: 3px;
  /* 垂直滚动条的宽度 */
  height: 5px;
  /* 水平滚动条的高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* 轨道颜色 */
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #888;
  /* 滑块颜色 */
}

/* 滑块hover效果 */
::-webkit-scrollbar-thumb:hover {
  background: #555;
  /* 滑块hover颜色 */
}

.suiruText {
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 22px;
  color: #1D2224;
  display: inline-block;
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/App.vue